import kycApi from 'api/kyc';
import rankingApi from 'api/rankingApi';
import userApi from 'api/userApi';
import walletApi from 'api/walletApi';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import {
  selectCurrentUser,
  selectIsLoggedIn,
  setCurrentUser,
  setCurrentUserRanking,
  setIsLoggedIn,
  setTokenPrice,
} from 'redux/userSlice';
import { getLocalStorage } from 'utils/sessionStorage';

const useUserDetail = () => {
  const dispatch = useAppDispatch();

  const isUserLoggedIn = useAppSelector(selectIsLoggedIn);
  const currentUser = useAppSelector(selectCurrentUser);

  const getUserDetail = () => {
    const accessToken = getLocalStorage('access_token_terabet');
    dispatch(setIsLoggedIn(!!accessToken));
  };

  const getUser = async () => {
    const { ok, body } = await userApi.getUser();
    if (ok && body) {
      dispatch(setCurrentUser(body));
      getTokenPrice(body.coinDto.symbol);
    }
  };

  const getKycToken = async () => {
    const { ok, body } = await kycApi.getAccessToken();
    if (ok && body) {
      return body.accessToken;
    }
  };

  const getTokenPrice = async (symbol: string) => {
    if (symbol !== 'USD') {
      const { ok, body } = await walletApi.getTokenPrice(symbol);
      if (ok && body) {
        dispatch(setTokenPrice(body.price));
      }
    } else {
      dispatch(setTokenPrice(1));
    }
  };

  const getUserRanking = async () => {
    const { ok, body } = await rankingApi.getUserRanking();
    if (ok && body) {
      dispatch(setCurrentUserRanking(body));
    }
  };

  const removeUserRanking = async () => {
    dispatch(setCurrentUserRanking(undefined));
  };

  return {
    getUserDetail,
    isUserLoggedIn,
    currentUser,
    getUser,
    getKycToken,
    getUserRanking,
    removeUserRanking,
  };
};

export default useUserDetail;
